/**
* LanguageRevision.js
* 
* Created on 14-mei-2014, 14:29:26
*
* @author Ivo Swartjes for Ranj
**/
export default class LanguageRevision {
    constructor(lpLabel, revisedText) {
        this.lpLabel = lpLabel;
        this.revisedText = revisedText;
    }
}
